document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('sd-assistance-modal');
  if (!modal) return;

  const openTriggers = document.querySelectorAll('[data-sd-assistance-open]');
  const closeTriggers = modal.querySelectorAll('[data-sd-assistance-close]');
  const dialog = modal.querySelector('.sd-assistance-modal__dialog');

  const openModal = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sd-modal-open');
    document.documentElement.classList.add('sd-modal-open');
    const firstField = modal.querySelector('input, textarea, button');
    firstField?.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sd-modal-open');
    document.documentElement.classList.remove('sd-modal-open');
  };

  openTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal();
    });
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      closeModal();
    });
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.classList.contains('sd-assistance-modal__overlay')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

});
